// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from 'gestalt';

// $FlowFixMe: new errors found from flow 0.96 upgrade
export const FlyoutContext = React.createContext(() => {});
type State = {|
  flyout: ?Object,
  showOnTopOfModal: boolean,
|};
type Props = {| children?: any |};

// $zIndexModal + 1 => Allows us to show Tooltips & Flyouts on top of modals
const TOP_OF_MODAL_Z_INDEX = 752;

class FlyoutProvider extends Component<Props, State> {
  state: State = {
    flyout: undefined,
    showOnTopOfModal: false,
  };

  setActive = (type?: 'flyout', options?: Object, showOnTopOfModal?: boolean = false) => {
    if (!type) {
      this.setState({ flyout: undefined });
    } else {
      const props = {
        ...options,
        onDismiss: () => {
          if (options && options.onDismiss) {
            options.onDismiss();
            this.setState({ flyout: undefined });
          }
        },
        positionRelativeToAnchor: false,
      };
      this.setState({
        flyout: { props },
        showOnTopOfModal,
      });
    }
  };

  render() {
    const { flyout, showOnTopOfModal } = this.state;
    return (
      <React.Fragment>
        <FlyoutContext.Provider value={this.setActive}>
          {this.props.children}
        </FlyoutContext.Provider>
        {flyout && (
          <div
            {...(showOnTopOfModal
              ? {
                  style: {
                    zIndex: TOP_OF_MODAL_Z_INDEX,
                    position: 'absolute',
                    top: 0,
                  },
                }
              : {})}
          >
            <Flyout {...flyout.props} />
          </div>
        )}
      </React.Fragment>
    );
  }
}

FlyoutProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FlyoutProvider;
